import { render, staticRenderFns } from "./PrescriptionMemed.vue?vue&type=template&id=9bafdd00&scoped=true"
import script from "./PrescriptionMemed.vue?vue&type=script&lang=js"
export * from "./PrescriptionMemed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bafdd00",
  null
  
)

export default component.exports